import { VueReCaptcha } from 'vue-recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueReCaptcha, {
    siteKey: '6LfA6PQfAAAAAGxbIv6ovlyu2aaEKLpRqiWgbycr',
  });
});